import React from 'react';
import { Box } from '@mui/material';
import { glassSx, mvkgTokens } from '../../theme/mvkgTokens';

export default function GlassCard({
  children,
  strong = false,
  padding = 3,
  onClick,
  sx = {},
  component: Component = 'div',
  ...rest
}) {
  return (
    <Box
      component={Component}
      {...rest}
      onClick={onClick}
      sx={{
        ...glassSx(strong),
        borderRadius: `${mvkgTokens.radius.xl}px`,
        p: padding,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        '&:hover': onClick
          ? { transform: 'translateY(-1px)', boxShadow: mvkgTokens.shadow.glass }
          : {},
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
